import React from "react";
import { ReactComponent as CheckIcon } from "../../assets/icons/check.svg";

export default ({ badgeCounter }: { badgeCounter?: string }) => (
  <span className={`badge ${!badgeCounter ? "active" : ""}`} data-cy="badge">
    {" "}
    {badgeCounter || <CheckIcon />}{" "}
  </span>
);
